import { ethers } from 'ethers'

/**
 * Sign-In With Ethereum: prompts the connected wallet to sign a login message,
 * exchanges it for a short-lived JWT from the Workers API, and returns the token.
 *
 * The signed message embeds the address + timestamp; the server recovers the
 * signer and issues a JWT bound to that address. Used to authenticate
 * write endpoints (e.g. off-chain report storage).
 */
export async function signInWithEthereum(): Promise<string> {
  if (!window.ethereum) throw new Error('MetaMask가 설치되어 있지 않습니다')

  const provider = new ethers.BrowserProvider(window.ethereum)
  const signer = await provider.getSigner()
  const address = (await signer.getAddress()).toLowerCase()
  const timestamp = Math.floor(Date.now() / 1000)
  const message = `Blockchain Challenge Platform Login\nAddress: ${address}\nTimestamp: ${timestamp}`
  const signature = await signer.signMessage(message)

  const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? ''
  const res = await fetch(`${apiBase}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ address, message, signature }),
  })
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { error?: string }
    throw new Error(err.error ?? '로그인에 실패했습니다')
  }
  const data = (await res.json()) as { token: string }
  return data.token
}
